import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import classNames from 'classnames';

import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';

import { useFormCreateStatus } from '../../controllers/Status/CreateStatusController';
import LoadingScreen from '../../components/LoadingScreen';

const StatusForm: React.FC = () => {
    const { getStatusFormController, handleStatusFormController } = useFormCreateStatus();

    const [registerFinished, setRegisterFinished] = useState(false);

    const history = useHistory();

    useEffect(() => {
        if (getStatusFormController.statusResponse?.status === 200) {
            setRegisterFinished(true);
        }
        if (getStatusFormController.statusEditedResponse?.status === 200 && !getStatusFormController.statusResponse) {
            setRegisterFinished(false);
        }
    }, [getStatusFormController.statusResponse, getStatusFormController.statusEditedResponse]);

    return (
        <div style={{ height: '100%' }} className="p-grid p-align-center p-justify-center">
            <Toast ref={getStatusFormController.toast} />
            {getStatusFormController.loading ? <LoadingScreen color="#0388e5" /> : <></>}
            <div className="p-col-12 p-md-8">
                <div className="card p-fluid">
                    <h5>Status</h5>
                    <div className="p-field">
                        <label htmlFor="name">Descrição</label>
                        <InputText disabled={registerFinished} id="name" type="text"
                            value={getStatusFormController.formik.values.DESCRICAO}
                            onChange={getStatusFormController.formik.handleChange('DESCRICAO')}
                        />
                        <div className={classNames("p-invalid popup-fade", {
                            'popup-form-active': getStatusFormController.formik.touched.DESCRICAO && getStatusFormController.formik.errors.DESCRICAO,
                            'popup-form-inactive': !(getStatusFormController.formik.touched.DESCRICAO && getStatusFormController.formik.errors.DESCRICAO),
                        })}>{getStatusFormController.formik.errors.DESCRICAO}</div>
                    </div>

                    <div className="p-fluid p-grid p-justify-between">
                        {getStatusFormController.statusResponse?.status === 200 && !registerFinished ?
                            <div className="p-col-12 p-md-4">
                                <Button
                                    type="button"
                                    label="Salvar Alterações"
                                    onClick={() => {
                                        getStatusFormController.formik.handleSubmit()
                                    }}
                                />
                            </div> :
                            getStatusFormController.statusResponse?.status === 200 && registerFinished ?
                                <div className="p-col-12 p-md-6 p-fluid p-grid" >
                                    <div className="p-col-12 p-md-5">
                                        <Button
                                            type="button"
                                            label="Editar"
                                            onClick={() => {
                                                setRegisterFinished(false);
                                            }}
                                        />
                                    </div>
                                    <div className="p-col-12 p-md-5" >
                                        <Button
                                            icon="pi pi-plus"
                                            type="button"
                                            className="p-button-success"
                                            label="Cadastrar novo"
                                            onClick={() => {
                                                getStatusFormController.formik.resetForm();
                                                setRegisterFinished(false);
                                                handleStatusFormController.setStatusResponse(null);
                                            }}
                                        />
                                    </div>
                                </div> :
                                <div className="p-col-12 p-md-4">
                                    <Button
                                        type="button"
                                        label="Cadastrar"
                                        onClick={() => getStatusFormController.formik.handleSubmit()}
                                    />
                                </div>
                        }

                        <div className="p-col-12 p-md-4">
                            <Button
                                type="button"
                                className="p-button-secondary"
                                label="Voltar para listagem"
                                onClick={() => history.goBack()}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>

    );
};

export default StatusForm;